<template>
  <div
    class="flex items-center gap-3 font-medium text-violet-700 sus:text-violet-text-negative 2nd:text-white"
  >
    <label v-if="label" class="typo-body-m-medium md:typo-body-l-medium">{{
      label
    }}</label>
    <HeadlessListbox v-slot="{ open }" v-model="data" :disabled="disabled">
      <div class="relative w-full">
        <HeadlessListboxButton
          class="
            group relative w-full text-left transition
            focus:outline-none
            focus-visible:border-surface-500 focus-visible:ring-2 focus-visible:ring-violet-600
            disabled:cursor-not-allowed
          "
          :class="[
            buttonClass ? buttonClass : 'min-w-[175px] bg-surface-300',
            disabled
              ? 'bg-surface-300/60 text-violet-text/50'
              : `
                cursor-pointer
                hover:bg-[#EFEBFF]
                sus:hover:bg-peach-600
                2nd:hover:bg-violet-dark-700 2nd:hover:bg-violet-text-dark
              `,
            {
              'rounded-sm py-[5px] pl-3 pr-8': variant === 'normal',
              'rounded py-5 pl-6 pr-20': variant === 'big',
            },
          ]"
        >
          <span
            class="
              block truncate typo-body-m-medium
              sus:typo-heading-s-semibold sus:md:typo-heading-m-semibold
              md:typo-body-l-medium
            "
          >
            {{ (labler ? labler(data) : data) || placeholder || '&nbsp;' }}
          </span>
          <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <IconChevron
              class="
                w-[8px] transition duration-300 ease-in-out
                group-hover:scale-x-105 group-hover:scale-y-90
              "
              :class="{
                '-rotate-90': !open,
                'rotate-90': open,
              }"
            />
          </span>
        </HeadlessListboxButton>

        <Transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <HeadlessListboxOptions
            class="style-scrollbar absolute z-10 mt-1 w-full"
            :class="[listboxClass ? listboxClass : 'rounded-sm bg-surface-300']"
          >
            <div
              v-if="arrow"
              class="absolute left-1/2 -z-10 size-3 -translate-x-1/2 -translate-y-1/2 rotate-45"
            />
            <div class="style-scrollbar max-h-60 w-full overflow-auto">
              <HeadlessListboxOption
                v-for="(entry, key) in entries"
                v-slot="{ active, selected }"
                :key="key"
                :value="entry"
                as="template"
              >
                <li
                  :class="[
                    active || selected ? 'rounded-md bg-surface-500' : '',
                    !selected ? 'cursor-pointer' : '',
                    'relative select-none px-3 py-2',
                  ]"
                >
                  <span class="block truncate text-base sus:text-xl">
                    {{ labler ? labler(entry) : entry }}
                  </span>
                </li>
              </HeadlessListboxOption>
            </div>
          </HeadlessListboxOptions>
        </Transition>
      </div>
    </HeadlessListbox>
  </div>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = withDefaults(
  defineProps<{
    label?: string
    entries: Record<string, string> | any[]
    modelValue: any
    placeholder?: string

    labler?: (entry: any) => string
    buttonClass?: HTMLAttributes['class']
    listboxClass?: HTMLAttributes['class']
    disabled?: boolean
    arrow?: boolean
    variant?: 'normal' | 'big'
  }>(),
  {
    variant: 'normal',
  },
)

const emit = defineEmits(['update:modelValue'])

const data = useVModel(props, 'modelValue', emit)
</script>
